import styled from 'styled-components'

export const StyledHeaderAside = styled.div`
  & > *:not(:first-child) {
    margin-left: 16px;
  }
`
